import { AuthConfig } from '@aws-amplify/core';

export const AmplifyConfigAuth: AuthConfig = {
    Cognito: {
    // region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID!,
    userPoolClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID!,
loginWith: {    
    oauth: {
        domain: process.env.REACT_APP_AUTH_COGNITO_DOMAIN!,
        scopes: ['openid', 'email', 'aws.cognito.signin.user.admin'],
        redirectSignIn: [process.env.REACT_APP_AUTH_CALLBACK_URL!],
        redirectSignOut: [process.env.REACT_APP_AUTH_LOGOUT_URL!],
        responseType: 'code',
    },
}
}
};